import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {
    transform(sizeInBytes?: number | null): string {
        if (typeof sizeInBytes !== 'number' || Number.isNaN(sizeInBytes) || sizeInBytes < 0) {
            return '';
        }

        if (sizeInBytes < 1024) {
            return `${Math.round(sizeInBytes)} B`;
        }

        const sizeInKb = sizeInBytes / 1024;
        if (sizeInKb < 1024) {
            return `${this.formatValue(sizeInKb)} KB`;
        }

        const sizeInMb = sizeInKb / 1024;

        return `${this.formatValue(sizeInMb)} MB`;
    }

    private formatValue(value: number): string {
        return value >= 10 ? value.toFixed(0) : value.toFixed(1);
    }
}
